import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";

const MobileNavbar = () => {
  const igniteLogoImage = require("./../assets/images/igniteLogo.png");
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="mainComponentMobHeader">
      {/* <ArrowBackIcon /> */}

      <div className="mobileHeader">
        <span>
          {" "}
          {location.pathname.slice(0, 5) === "/Meet" ? (
            <ArrowBackIcon onClick={() => navigate("/")} />
          ) : (
            ""
          )}{" "}
          Meets
        </span>
        <div className="igniteLogoDivMobile">
          <img src={igniteLogoImage} alt="" />
        </div>
      </div>
    </div>
  );
};

export default MobileNavbar;
